
    import $ from 'jquery'
    import { RootObject,LinkedPDF } from '@/Classes/Interfaces';
    import { defineComponent } from 'vue';
import CollapseComp from '@/Components/CollapseComp.vue';

export default defineComponent({
  components: { CollapseComp },
    data:function() {
        return {
            
        }
    },
    methods:{
        loadData: function () {
            // eslint-disable-next-line
            let self = this;
            $.getJSON("/Data/Data.json", function (data: RootObject) {
               console.log(data) 
               let Links:LinkedPDF[] = data.linkedPDF;
               console.log(Links)
               let BookingLink = Links.find(function(e){
                return e.name == 'BookingPDF'
               })?.link;
               console.log(BookingLink);
               $("#bookingFormPreview").attr("src",BookingLink!);
            });
        },
        clickExpand:function(){
            $(".dropBodyBlock").toggleClass("activeBlock");
        }
    },
    created:function(){
        this.loadData();
    }
})
